import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full relative overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=A%20warm%20inviting%20reading%20nook%20with%20bookshelves%20full%20of%20colorful%20manga%20books%2C%20soft%20cozy%20lighting%2C%20comfortable%20atmosphere%2C%20stylized%20illustration%2C%20warm%20amber%20and%20golden%20tones%2C%20clean%20composition%2C%20peaceful%20vibe&width=1920&height=400&seq=cta-manga-2026&orientation=landscape"
        alt="香香漫画 - 开启阅读之旅"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/80 via-foreground-900/50 to-foreground-900/30"></div>
      <div className="relative z-10 max-w-[1400px] mx-auto px-4 md:px-6 py-12 md:py-20">
        <div className="max-w-lg">
          <h2 className="text-2xl md:text-3xl font-heading text-white mb-3">
            开启你的漫画之旅
          </h2>
          <p className="text-white/70 text-sm leading-relaxed mb-6">
            海量韩漫、日漫、国漫免费在线阅读，下拉式追更体验，随时随地享受阅读乐趣！
          </p>
          <Link
            to="/category/kr"
            className="inline-flex px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full text-sm transition-all duration-300 whitespace-nowrap"
          >
            立即探索
          </Link>
        </div>
      </div>
    </section>
  );
}